import { AptunoButton, Icon, SIZES, useResponsive, VARIANTS } from '@aptuno/aptuno-ui';
import { useRouter } from 'next/router';
import React from 'react';
import {
  ActionsBarRoot,
  BigTitle,
  FlexIcon,
  HeaderSection,
  HighlightedText,
  ListItem,
  Subtitle,
  TextNormal,
  TitleDescription,
} from '../EstateApplication.styled';
import { ContentSection } from './SuccessfulApplicationScreen.styled';

export const SuccessfulApplicationScreen = () => {
  const router = useRouter();
  const { isMobile } = useResponsive();

  const handleOnClickBtn = () => {
    router.push('/perfil');
  };
  return (
    <>
      <HeaderSection bgColor="#FFFFFF" horizontalAlign="center" padding={isMobile ? '40px 0 24px 0' : '108px 0 32px 0'}>
        <FlexIcon>
          <Icon width="64px" height="64px" icon="circle-check" />
        </FlexIcon>
        <BigTitle margin="28px 0 16px 0">¡Gracias por aplicar!</BigTitle>
        <TitleDescription>Estudiaremos tu información para darte una respuesta rápidamente.</TitleDescription>
      </HeaderSection>
      <ContentSection bgColor="#F8F8F8" horizontalAlign="flex-start">
        <BigTitle color={'#0055FB'} margin="40px 0 20px 0" align={isMobile ? 'left' : 'center'}>
          Ahora, ¿qué sigue?
        </BigTitle>
        <Subtitle>Una vez lo tengamos, te enviaremos tu resultado a través de WhatsApp.</Subtitle>
        <TextNormal margin="16px 0 32px 0">
          Te comunicaremos el resultado de tu aplicación y las acciones siguientes que deberás tomar para arrendar el
          inmueble ideal para tí.
        </TextNormal>
        <Subtitle>¿Qué resultados puedo esperar?</Subtitle>
        <TextNormal>
          En Aptuno, nos interesa que puedas mudarte al inmueble que te encanta, por lo que tenemos muchas alternativas
          para que lo logres.
        </TextNormal>
        <ListItem iconColor={'#0055FB'} verticalAlign={'baseline'}>
          <div>
            <Icon width={'20px'} height={'20px'} icon="gear-check" />
          </div>
          <TextNormal>
            <HighlightedText>Con ingresos suficientes y una vida crediticia saludable,</HighlightedText> no tendrás
            mayor problema para firmar el contrato y mudarte. Fácil, rápido y sin papeleo.
          </TextNormal>
        </ListItem>
        <ListItem iconColor={'#0055FB'} verticalAlign={'baseline'}>
          <div>
            <Icon width={'20px'} height={'20px'} icon="warning" />
          </div>
          <TextNormal>
            <HighlightedText>
              Si no tienes los ingresos suficientes o hay problemas con tu vida crediticia,
            </HighlightedText>{' '}
            tal vez necesites un co-arrendatario o pagar una fianza para arrendar el inmueble.
          </TextNormal>
        </ListItem>
        <Subtitle>En cualquier caso, no te abandonaremos. </Subtitle>
        <TextNormal>
          Uno de nuestros agentes estará encargado de encontrar una solución para tí. En poco tiempo podrás mudarte al
          inmueble perfecto.
        </TextNormal>
        <ActionsBarRoot>
          <AptunoButton appearance={VARIANTS.PRIMARY} size={SIZES.BIGGEST} onClick={handleOnClickBtn}>
            Ir a mi perfil
          </AptunoButton>
        </ActionsBarRoot>
      </ContentSection>
    </>
  );
};
